import { FC, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useStyles } from './styles';
import { Grid, Paper, Tab } from '@material-ui/core';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ArrowRightIcon from '@material-ui/icons/ArrowRight';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
import TabPanel from '../TabPanel';
// import SourceImg from '../../assets/source.svg';
// import ldapImg from '../../assets/ldap.svg';
import { MappingFields } from './TabsContent';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { DataSources } from './TabsContent/DataSources';
import { Breadcrumbs } from '@material-ui/core';

function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}
export const SynchronizationBlocks: FC = observer(() => {
  const {
    importStore: {
      step,
      ldapConnection,
      // ldapSyncHistory,
      ldapGetSyncProcess,
      setStep,
      ldapGetConnectOptions,
      ldapPauseResume,
      stepNumberData,
      ldapLastSync: { status },
    },
    notificationStore: { openNotification },
  } = useStore();

  // useQuery('ldapGetSyncProcess', () => ldapGetSyncProcess(), {
  //   onError: ({ message }: Error) => openNotification('error', message),
  //   refetchInterval: 5 * 1000,
  //   enabled: !!lastSyncTime && status === '0',
  // });

  // const syncHistoryReq = useQuery('ldapSyncHistory', () => ldapSyncHistory(), {
  //   onError: ({ message }: Error) => openNotification('error', message),
  // });

  const ldapGetConnectOptionsReq = useQuery('ldapGetConnectOptions', () => ldapGetConnectOptions(), {
    onSuccess: () => {
      setStep('one');
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const ldapPauseResumeReq = useMutation('ldapPauseResumeReq', () => ldapPauseResume(), {
    onSuccess: () => {
      ldapGetSyncProcess();
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });

  // const getDuration = (given: any) => {
  //   const date1 = new Date(given);
  //   const date2 = new Date();
  //   const diff = date2.getTime() - date1.getTime();
  //   let msec = diff;
  //   const hh = Math.floor(msec / 1000 / 60 / 60);
  //   msec -= hh * 1000 * 60 * 60;
  //   const mm = Math.floor(msec / 1000 / 60);
  //   msec -= mm * 1000 * 60;
  //   const ss = Math.floor(msec / 1000);
  //   msec -= ss * 1000;
  //   return hh + 'h: ' + mm + 'm: ' + ss + 's';
  // };
  // const reRenderComp = () => {
  //   ldapPauseResumeReq.mutate();
  // };

  useEffect(() => {
    // ldapPauseResumeReq.mutate();
  }, [ldapPauseResumeReq, status]);

  const classes = useStyles();

  // const hostname = window.location.hostname.split('.');

  useAppPreloader(
    // syncHistoryReq.isFetching ||
    ldapGetConnectOptionsReq.isLoading || ldapGetConnectOptionsReq.isLoading || ldapPauseResumeReq.isLoading
  );
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Breadcrumbs className={classes.tabs} separator='›'>
          <Tab value='one' label='UPLOAD USER ACCOUNTS' {...a11yProps('one')} className={classes.label} />
          {stepNumberData() === 'two' ? (
            <Tab
              value='two'
              label='Map Fields'
              {...a11yProps('two')}
              className={classes.label}
              style={{ color: 'blue' }}
            />
          ) : null}
        </Breadcrumbs>
        {/* <Tabs
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          value={step}
          indicatorColor='secondary'
          textColor='secondary'
          //aria-label='disabled tabs example'
        >
          <Tab value='one' label='UPLOAD USER ACCOUNTS' {...a11yProps('one')} className={classes.label} />
          {stepNumberData() === 'two' ? (
            <Tab value='two' label='Map Fields' {...a11yProps('two')} className={classes.label} />
          ) : null}
        </Tabs> */}

        <div className={classes.tabBox}>
          <TabPanel value={step} index='one'>
            <DataSources />
          </TabPanel>
          <TabPanel value={step} index='two'>
            <MappingFields />
          </TabPanel>
          <TabPanel value={step} index='one_status'>
            <Paper className={classes.boxPaper}>
              <Paper className={classes.container}>
                <p className={classes.containerTitle}>Contacting your following LDAP Server:</p>
                <p>&nbsp;</p>
                <p className={classes.containerDesc}>
                  {ldapConnection?.host}:{ldapConnection?.port}
                </p>
              </Paper>
            </Paper>
          </TabPanel>
          <TabPanel value={step} index='two_status'>
            <Paper className={classes.boxPaper}>
              <Paper className={classes.container}>
                <p className={classes.containerTitle}>Contacting your following LDAP Server:</p>
                <p>&nbsp;</p>
                <p className={classes.containerDesc}>
                  {ldapConnection?.host}:{ldapConnection?.port}
                </p>
              </Paper>
            </Paper>
          </TabPanel>
          <TabPanel value={step} index='three_status'>
            <Paper className={classes.boxPaper}>
              <Paper className={classes.container}>
                <p className={classes.containerTitle}>Saving Attribute Mappings ...</p>
                <p>&nbsp;</p>
                <p className={classes.containerDesc}>LDAP import will be based</p>
                <p className={classes.containerDesc}>on the attribute mappings defined earlier.</p>
              </Paper>
            </Paper>
          </TabPanel>
          <TabPanel value={step} index='four_status'>
            <Paper className={classes.boxPaper}>
              <Paper className={classes.container}>
                <p className={classes.containerTitle}>Establishing connection between…</p>
                <p>&nbsp;</p>
                <p className={classes.containerDesc}>Your existing LDAP server: {ldapConnection?.host}</p>
                <p className={classes.containerDesc}>and</p>
                <p className={classes.containerDesc}>EasyIdentity Cloud Servers.</p>
              </Paper>
            </Paper>
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
